import bags from "../../../images/Products/bags_big.jpg";
import bonnet from "../../../images/Products/bonnet.jpg";
import casquetteNike from "../../../images/Products/casquetteNike.jpg";
import mens from "../../../images/Products/mens.jpg";
import sweatdress from "../../../images/Products/sweatdress.jpg";
import sweatermen from "../../../images/Products/sweatermen.jpg";
import sweatpant from "../../../images/Products/sweatpant.jpg";
import womendress from "../../../images/Products/womendress.jpg";

const ProductsData = [
  {
    image: bags,
    name: " Big bag for Women ",
    price: "$15.00 USD",
  },
  {
    image: bonnet,
    name: "cool style Bonnet",
    price: "$12.00 USD",
  },
  {
    image: casquetteNike,
    name: "Orange Nike Cap",
    price: "$14.00 USD",
  },
  {
    image: mens,
    name: "Cuff Shirt",
    price: "$19.99 USD",
  },
  {
    image: sweatdress,
    name: "Sweater dresses ",
    price: "$88.00 USD",
  },
  {
    image: sweatermen,
    name: "Mens Sweater",
    price: "$52.90 USD",
  },
  {
    image: sweatpant,
    name: "Sweater dresses ",
    price: "$25.00 USD",
  },
  {
    image: womendress,
    name: "Women dresse",
    price: "$100.00 USD",
  },
];

export default ProductsData;
